import * as React from "react";

import { useCandyTheme } from "../../../../Internals/ThemeProvider/CandyTheme/UseCandyTheme";

export function EmptyListIcon(): JSX.Element {
    const theme = useCandyTheme();

    const iconColors = theme.graphics.light;
    return (
        <svg width="85" height="87" viewBox="0 0 85 87" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M42.1615 86.323C65.4466 86.323 84.323 67.4466 84.323 44.1615C84.323 20.8763 65.4466 2 42.1615 2C18.8763 2 0 20.8763 0 44.1615C0 67.4466 18.8763 86.323 42.1615 86.323Z"
                fill={iconColors.strokeColor}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M69.4722 71.507H16.9166V1.19189H52.2552L69.4722 18.3705V71.507Z"
                fill={iconColors.fillColor}
                stroke={iconColors.strokeColor}
                strokeWidth="2"
            />
            <path d="M68.8748 19.0686H51.5553V1.19189" stroke={iconColors.strokeColor} strokeWidth="2" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M57.5278 83.4249H4.97227V13.1099H40.3109L57.5278 30.2884V83.4249Z"
                fill={iconColors.fillColor}
                stroke={iconColors.strokeColor}
                strokeWidth="2"
            />
            <path d="M56.9304 30.9866H39.611V13.1099" stroke={iconColors.strokeColor} strokeWidth="2" />
        </svg>
    );
}
